import React from 'react';
import { map, isEmpty, findIndex } from 'lodash';
import searchQuery from 'query-string';

// Local Dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { widgetsTabFlow as WidgetsTabFlow } from 'modules/widgetsTabFlow';

// Success View
export const memberInfoSettingsSuccess = ( props ) => {

    // get query string params
    const queryParams = searchQuery.parse( props.location.search );

    /*------------------*/

    // set active step index
    let activeStepIndex = 0;

    if( ! isEmpty( queryParams.memberInfoSettings ) ) {
        activeStepIndex = findIndex( props.tabs, { name: queryParams.memberInfoSettings } );
    }

    /*------------------*/

    return (
        <div className='ui-member-info-settings'>
            <WidgetsTabFlow
                tabs={ props.tabs }
                theme='plain'
                requestPayload={ props.requestPayload }
                activeTabIndex={ -1 === activeStepIndex ? 0 : activeStepIndex }
            />
        </div>
    );
};

// set display name
memberInfoSettingsSuccess.displayName = 'memberInfoSettingsSuccess';

// set default props
memberInfoSettingsSuccess.defaultProps = {};

// prop types
memberInfoSettingsSuccess.propTypes = {};

/***************************************** */

// Preloader view
export const memberInfoSettingsPreloader = () => {
    return (
        <div className='ui-member-info-settings-preloader'>
            <div className='ui-member-info-settings-preloader__tab-list'>
                <div className='ui-member-info-settings-preloader__tab-list__tab'></div>
                <div className='ui-member-info-settings-preloader__tab-list__tab'></div>
                <div className='ui-member-info-settings-preloader__tab-list__tab'></div>
            </div>
            
            <div className='ui-member-info-settings-preloader__tab-container'>
                {
                    map( [ 1, 2, 3 ], item => {
                        return (
                            <div key={ item } className='ui-member-info-settings-preloader__tab-container__contact'>
                                <div className='ui-member-info-settings-preloader__tab-container__contact__type-detail'>
                                    <div className='ui-member-info-settings-preloader__tab-container__contact__type-detail__type'></div>
                                    <div className='ui-member-info-settings-preloader__tab-container__contact__type-detail__default' ></div>
                                </div>
                                <div className='ui-member-info-settings-preloader__tab-container__contact__contact-number'></div>
                                <div className='ui-member-info-settings-preloader__tab-container__contact__partition' />
                                <div className='ui-member-info-settings-preloader__tab-container__contact__type-detail'>
                                    <div className='ui-member-info-settings-preloader__tab-container__contact__type-detail__type'></div>
                                    <div className='ui-member-info-settings-preloader__tab-container__contact__type-detail__default' ></div>
                                </div>
                            </div>
                        );
                    } )
                }
            </div>
        </div>
    );
};

// set display name
memberInfoSettingsPreloader.displayName = 'memberInfoSettingsPreloader';

// set default props
memberInfoSettingsPreloader.defaultProps = {};

// prop types
memberInfoSettingsPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberInfoSettings as MemberInfoSettings } from 'ui/views/widgets/memberInfoSettings';
 *
 * // render
 * <MemberInfoSettings propName='propValue'/>
 */

export const memberInfoSettings = withNetworkState( memberInfoSettingsPreloader, memberInfoSettingsSuccess );
